import React from 'react'
import "./OpenAi.css"
import {possibilty} from "../../constants"
function OpenAi() {
  return (
    <div className="App_OpenAi" id="OpenAi">
      <div className="OpenAi_container">
        
        <div className="OpenAi_main">
          <div className="col-left">
            <img src={possibilty} alt="Open AI" />
          </div>
          <div className="col-right">
            <p className="col-right-para">
              Request Early Access to Get Started
            </p>
            <p className="col-title">
              The possibilities are
              beyond your imagination
            </p>

            <p className="col-info">
              Yet bed any
              for travelling assistance indulgence unpleasing.Not thoughts all exercise blessing.Indulgence way everything joy alteration boisterous the attachment.Party we years to order allow asked of .
            </p>

            <a href="#">
              Request Early Access to Get Started
            </a>
          </div>
        </div>
        <div className="Request_box">
          <div className="Request_content">

            <div>
              <p className="request-intro">
                Request Early Access to Get Started
              </p>

              <h3 className="title">
                Register Today & start exploring the endless possibilities.
              </h3>
            </div>
            
            <button className="btn">
              get started
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OpenAi